import PageTitle from '@ausbom/page-title';
import isobarsDark01 from '@core-systems/frontend-shared/src/assets/images/isobars-dark-01.svg?url';
import isobarsDark02 from '@core-systems/frontend-shared/src/assets/images/isobars-dark-02.svg?url';
import isobarsDark03 from '@core-systems/frontend-shared/src/assets/images/isobars-dark-03.svg?url';
import isobarsDark04 from '@core-systems/frontend-shared/src/assets/images/isobars-dark-04.svg?url';
import './AppHero.scss';

type AppHeroProps = {
  title: string;
  subTitle?: string;
  metadata?: string;
  isoBars?: number; // min - 1, max - 4 => see bgMap
  small?: boolean;
};

const bgMap: Record<number, string> = {
  1: isobarsDark01,
  2: isobarsDark02,
  3: isobarsDark03,
  4: isobarsDark04
};

export default function AppHero({ title, subTitle, metadata, isoBars = 1, small = false }: AppHeroProps) {
  const isoBarsIdx = Number(isoBars) > 0 && Number(isoBars) <= Object.keys(bgMap).length ? Number(isoBars) : 1;
  const backgroundImg = bgMap[isoBarsIdx];

  return (
    <section
      className="app-hero"
      style={{ backgroundImage: `url(${backgroundImg})` }}
      aria-label={`${title}${subTitle ? ' ' + subTitle : ''}`}
    >
      <div className="contained">
        <PageTitle title={title} subTitle={subTitle} subTitleAs="p" metaData={metadata} metaDataAs="p" small={small} />
      </div>
    </section>
  );
}
